export interface EstimateToCustomerRequest {
  account_id: string;
  project_id?: string;
  customer_id?: string;
  estimate_id?: string;
  recipient_email: string;
  recipient_phone: string;
  send_method: string;
  message_for: string;   //--estimate, invoice, account_invite, password_reset
}


export interface Estimate {
  estimate_id: string;
  name: string;
  description: string;
  terms_and_conditions: string;
  project_id: string;
  customer_id: string;
  time_to_complete_hr: number;
  time_to_complete_day: number;
  tax_rate: number;
  discount_usd: number;
  tax_amount?: number;
  final_total?: number;
}

export interface ItemizedEstimate {
  itemized_estimate_id: string;
  code: string;
  description: string;
  unit_price_dollar: number;
  quantity: number;
  sub_total_dollar: number;
  cost_type: 'all' | 'labor' | 'material';
  duration_hour: number;
  estimate_id: string;
  is_optional: boolean;
}

export interface CreateItemizedEstimateRequest {
  code: string;
  description: string;
  unit_price_dollar: number;
  quantity: number;
  sub_total_dollar: number;
  cost_type: 'all' | 'labor' | 'material';
  duration_hour: number;
  estimate_id: string;
  is_optional: boolean;
}

// ⭐ UPDATED to match actual API response
export interface EstimateTotal {
  total_dollar: number | string;        
  total_hour: number | string;          
  non_optional_dollar: number | string; 
  non_optional_hour: number | string;   
  optional_dollar: number | string;     
  optional_hour: number | string;       
  tax_rate?: number;                     
  tax_amount?: number;                   
  discount_usd?: number;                 
  final_total?: number;                  
}

export interface LineItem {
  id: number;
  code: string;
  description: string;
  unit_price_dollar: number;
  quantity: number;
  sub_total_dollar: number;
  cost_type: 'all' | 'labor' | 'material';
  duration_hour: number;
  estimate_id: string;
  is_optional: boolean;
}

export interface EstimateProjectCustomer {
    estimate_id: string;
    name: string;
    description: string;
    time_to_complete_hr: number;
    time_to_complete_day: number;
    terms_and_conditions: string;
    tax_rate: number;
    discount_usd: number;
    total_dollar: number;
    tax_amount: number;
    final_total: number;
    total_hour: number;
    non_optional_dollar: number;
    non_optional_hour: number;
    optional_dollar: number;
    optional_hour: number;
    project_id: string;
    customer_id: string;
    project_name: string;
    project_description: string;
    project_type: string;
    project_start_date?: string;
    project_end_date?: string;
    customer_first_name: string;
    customer_last_name: string;
    customer_address_1: string;
    customer_address_2?: string;
    customer_city: string;
    customer_state: string;
    customer_zip: string;
    customer_phone: string;
    customer_email: string;
}

export interface EstimateWithItemizedEstimate {
  estimate_id: number;
  name: string;
  description: string;
  company_code: number;
  project_id: number;
  customer_id: number;
  time_to_complete_hr: number;
  time_to_complete_day: number;
  terms_and_conditions: string;
  tax_rate: number;
  discount_usd: number;
  tax_amount: number;
  final_total: number;
  created_at: string;
  updated_at: string;

  itemized_estimates: {
    itemized_estimate_id: number;
    description: string;
    unit_price_dollar: string;
    quantity: number;
    sub_total_dollar: string;
    cost_type: string;
    duration_hour: string;
    company_code: number;
    estimate_id: number;
    is_optional: boolean;
    created_at: string;
    updated_at: string;
    code: string;
  }[];
}

export interface EstimateWithItemsRequest {
  name: string;
  description: string;
  terms_and_conditions: number;
  project_id: number;
  customer_id: number;
  time_to_complete_hr: number;
  time_to_complete_day: number;
  tax_rate: number;
  discount_usd: number;
  itemized_estimates: {
    code: string;
    description: string;
    unit_price_dollar: string;
    sub_total_dollar: string;
    cost_type: string;
    duration_hour: string;
    quantity: number;
    is_optional: boolean;
  }[];
}

export const default_terms_and_conditions =
  " This estimate is valid for 5 business days from the date of issuance. The pricing provided covers only the specific items and work detailed above. " +
  "All materials will meet the specifications described, and all work will be performed in a professional, workmanlike manner according to industry standards. " +
  "If unforeseen circumstances arise during the project that would result in costs exceeding this estimate, we will immediately notify you and obtain " +
  "your written approval before proceeding with any additional work. Payment Schedule: (1) 50% deposit required upon acceptance of estimate; (2) 25% due " +
  "at project commencement; (3) 25% due upon project completion and final inspection.";